module.exports = __webpack_public_path__ + "platzi.png?86e480e12b20822805423662a2cb3d13";


//////////////////
// WEBPACK FOOTER
// ./src/assets/platzi.png
// module id = 39
// module chunks = 0